const Play = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 23 22" fill="none">
      <path
        d="M4.27734 10.9999V7.78601C4.27734 3.79573 7.10304 2.1617 10.5607 4.15684L13.3503 5.76379L16.1398 7.37073C19.5975 9.36587 19.5975 12.6339 16.1398 14.6291L13.3503 16.236L10.5607 17.843C7.10304 19.8381 4.27734 18.2041 4.27734 14.2138V10.9999Z"
        stroke={color}
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default Play;
